import * as DateFns      from 'date-fns';
import * as Forms        from '../components/forms';
import OnboardingSection from './onboarding_section';
import React             from 'react';
import useCompleted      from './use_completed';


export default function IntegrationSection({ scheduledCallDate, integrationName, updateOnboarding }) {
  const { isCollapsed, complete } = useCompleted('onboarding-integration-completed', false);

  const record        = { integrationName };
  const date          = DateFns.parseISO(scheduledCallDate);
  const formattedDate = DateFns.format(date, 'EEEE, MMMM do, yyyy');
  const formattedTime = DateFns.format(date, 'h:mm aaaa');
  const timezone      = getTimeZone(date);

  async function save(onboarding) {
    try {
      await updateOnboarding(onboarding);
      complete();
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <OnboardingSection className="integration" collapsed={isCollapsed}>
      <h2>Automate your workflow</h2>
      <div className="not-completed-section">
        <p>
          To automatically pull in customer contact information for messaging and review requests, we need to connect to your existing software.
        </p>
        <Forms.Form record={record} save={save}>
          <FormFields/>
        </Forms.Form>
        <p>
          Our onboarding team will connect Broadly with your software during your scheduled call on <strong>{formattedDate} at {formattedTime} ({timezone})</strong>.
        </p>
      </div>
    </OnboardingSection>
  );
}


function FormFields({ ...form }) {
  const label       = 'Please list any software you use to manage your customer contact information';
  const placeholder = 'e.g. QuickBooks Online, Mitchel 1';
  return (
    <ul>
      <Forms.Textarea {...form} label={label} name="integrationName" placeholder={placeholder}/>
      <Forms.Button {...form} label="Submit"/>
    </ul>
  );
}


function getTimeZone(date) {
  return date.toString().replace(/.*\((.+)\).*/, '$1');
}
